const axios = require('axios');
const ERRORS = require('./platform/errors').default;
require('es6-promise').polyfill();

function sendRaq(url, data) {
  const token = document.querySelector('input#token')
                && document.querySelector('input#token').value
    ? document.querySelector('input#token').value : '';
  const data64 = Buffer.from(JSON.stringify(data)).toString('base64');
  if (!token) {
    window.console.warn(ERRORS.noTokenProvided);
  }
  return axios.post(url, `"${data64}"`, {
    headers: {
      RaqToken: `${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  })
    .then((response) => response);
}

const quoterequest = {
  sendRaq,
};

module.exports = quoterequest;
